import { Link } from 'react-router-dom';
import LegalTop from '../components/LegalTop';
import './legal.css';

const ITEMS = [
  {
    q: 'How do I place a delivery?',
    a: 'From Home, tap Deliver, enter the pickup and drop-off, then confirm the package details and book.',
  },
  {
    q: 'How do I track my order?',
    a: 'Open Orders and tap the delivery: it shows each step, and your rider on the map once one is on the way.',
  },
  {
    q: 'Which payment methods are supported?',
    a: 'Cash: you pay the rider the price you booked at, at drop-off.',
  },
  {
    q: 'How do I update my profile?',
    a: 'Go to Profile, open Personal information, change your details and save.',
  },
  {
    q: 'I can’t log in — what should I check?',
    a: 'Use the email and password you registered with. If you have forgotten the password, tap Forgot password? on the sign-in screen.',
  },
  {
    q: 'Who do I contact for help?',
    a: 'Go to Profile, then Help & support, to call, WhatsApp or email the InGo office.',
  },
];

export default function FAQsPage() {
  return (
    <main className="legal-page">
      <div className="legal-card legal-card--pad-top">
        <LegalTop title="FAQs" fallback="/profile" />


        <div className="legal-faq-list">
          {ITEMS.map(({ q, a }) => (
            <details key={q} className="legal-faq">
              <summary className="legal-faq__q">{q}</summary>
              <p className="legal-faq__a">{a}</p>
            </details>
          ))}
        </div>

        <p className="legal-footnote">
          Still stuck?{' '}
          <Link to="/help-support" className="legal-inline-link">
            Help &amp; Support
          </Link>
        </p>
      </div>
    </main>
  );
}
